import { fromJS } from 'immutable';

import { fetchExceptionsRoutine, resolveExceptionRoutine } from '../routines';
import {  updateOrAdd } from './helper';

const initialState = fromJS({
  exceptions: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchExceptionsRoutine.SUCCESS:
      return state.set('exceptions', fromJS(action.payload.response)).set('loading', false);
    case fetchExceptionsRoutine.FAILED:
      return state.set('error', action.error).set('loading', false);

    case resolveExceptionRoutine.SUCCESS:
      return state.updateIn(['exceptions', 'data'], updateOrAdd(fromJS(action.payload.response.data)));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/exceptions.js